/**
 * Assistenza: da qui un cliente del gestionale apre una richiesta.
 *
 * Prima non esisteva nessun modo di chiedere aiuto da dentro l'applicazione.
 * La richiesta finisce in controll.omai.cloud/richieste, coda assistenza, e
 * non nella posta di qualcuno: cosi' resta anche se la mail non parte.
 *
 * Il modulo commerciale sta invece nella vetrina, prima del login. I due non
 * vanno mai sulla stessa schermata: chi ha un problema e si trova davanti un
 * modulo commerciale scrive li' dentro, e la richiesta finisce nella coda
 * sbagliata.
 */
import React from 'react';
import { LifeBuoy } from 'lucide-react';
import { PageContainer, PageHeader, Card, CardBody } from '../components/ui';
import ModuloContatto from '../components/ModuloContatto';
import { MODULO_ASSISTENZA } from '../config/moduli';

const AssistenzaPage: React.FC = () => (
  <PageContainer>
    <PageHeader icon={<LifeBuoy />} title="Assistenza" />

    <Card>
      <CardBody>
        <ModuloContatto chiave={MODULO_ASSISTENZA} />
      </CardBody>
    </Card>
  </PageContainer>
);

export default AssistenzaPage;
